import React, { Component } from 'react'
import Icon from '../../../../../../components/Icon'
import styled from 'styled-components'

const StyledApendIcon = styled(Icon)`
  position: absolute;
  right: 1em;
  color: ${(props) => props.theme.color.textTertiary};
  top: 10px;
`

class PasswordEye extends Component {
  constructor(props) {
    super(props)
    this.state = {
      visible: false,
    }
  }
  changeVisibility(currentState, callBack) {
    if (currentState) {
      callBack(false)
      this.setState({
        visible: false,
      })
    } else {
      callBack(true)
      this.setState({
        visible: true,
      })
    }
  }
  render() {
    return (
      <div onClick={() => this.changeVisibility(this.state.visible, this.props.onClick)}>
        {this.state.visible && <StyledApendIcon icon="eye" />}
        {!this.state.visible && <StyledApendIcon icon="closedEye" />}
      </div>
    )
  }
}

PasswordEye.defaultProps = {
  onClick: () => {},
}

export default PasswordEye
